export const formatNumbers = (number, numberOfDecimals = 2) => {
  if (number === '') return '';

  const decimalsToUse = numberOfDecimals === 0 ? 0 : numberOfDecimals;
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimalsToUse,
    maximumFractionDigits: decimalsToUse,
  }).format(number);
};
